import { Narzedzie } from '../../serwis-mapowy/modele/narzedzia';
import { NarzedziaWykonawcze } from './narzedzia.reducer';

export const NARZEDZIA_STERUJACE_ID = {
  DOKONAJ_POMIARU: 'DOKONAJ_POMIARU',
  PRZEJDZ_DO_WSPOLRZEDNYCH: 'PRZEJDZ_DO_WSPOLRZEDNYCH',
  SZLAK:'SZLAK'
};

export const NARZEDZIA_WYKONAWCZE_ID = {
  INFORMACJE_O_WSPOLRZEDNYCH: 'INFORMACJE_O_WSPOLRZEDNYCH',
  DOKONAJ_POMIARU: 'DOKONAJ_POMIARU',
  PRZEJDZ_DO_WSPOLRZEDNYCH: 'PRZEJDZ_DO_WSPOLRZEDNYCH',
  SZLAK:'SZLAK'
};


const NARZEDZIA_WYKONAWCZE_INFORMACJE_O_WSPOLRZEDNYCH = {
  id: NARZEDZIA_WYKONAWCZE_ID.INFORMACJE_O_WSPOLRZEDNYCH,
  desktop: true,
  mobile: true
} as NarzedziaWykonawcze;

const NARZEDZIA_WYKONAWCZE_DOKONAJ_POMIARU = {
  id: NARZEDZIA_WYKONAWCZE_ID.DOKONAJ_POMIARU, desktop: true, mobile: true
} as NarzedziaWykonawcze;

const NARZEDZIA_WYKONAWCZE_PRZEJDZ_DO_WSPOLRZEDNYCH = {
  id: NARZEDZIA_WYKONAWCZE_ID.PRZEJDZ_DO_WSPOLRZEDNYCH,
  desktop: true,
  mobile: true
} as NarzedziaWykonawcze;

const NARZEDZIA_WYKONAWCZE_SZLAK = {
  id: NARZEDZIA_WYKONAWCZE_ID.SZLAK,
  desktop: true,
  mobile: true
} as NarzedziaWykonawcze;

export const DEFINICJA_NARZEDZI_WYKONAWCZYCH = new Map<string, NarzedziaWykonawcze>([


  [NARZEDZIA_WYKONAWCZE_ID.PRZEJDZ_DO_WSPOLRZEDNYCH, NARZEDZIA_WYKONAWCZE_PRZEJDZ_DO_WSPOLRZEDNYCH],
  [NARZEDZIA_WYKONAWCZE_ID.DOKONAJ_POMIARU, NARZEDZIA_WYKONAWCZE_DOKONAJ_POMIARU],
  [NARZEDZIA_WYKONAWCZE_ID.INFORMACJE_O_WSPOLRZEDNYCH, NARZEDZIA_WYKONAWCZE_INFORMACJE_O_WSPOLRZEDNYCH],
   [NARZEDZIA_WYKONAWCZE_ID.SZLAK, NARZEDZIA_WYKONAWCZE_SZLAK],
]);

export const NARZEDZIA_STERUJACE_WARSTW = [

]





